<template>
  <div v-if="address && email" class="container">
    <div class="row">
      <div class="col-md-12">
        <hr class="mt-8 mb-8" />
        <div class="contact-information">
          <div class="address mb-2">
            <span v-if="$store.state.subdomain">
              Website content created by
              <b>{{ $store.state.subdomain.company.name }}</b>
              <span
                v-if="
                  $store.state.subdomain?.platform?.name === 'Teemill Trading'
                "
                class="smaller"
              >
                Hosted by Teemill
              </span>
            </span>
            <span v-else>
              Company Address | Teemill Tech Ltd. {{ email }}
              <b>{{ address.replace(/\n/g, ', ') }}</b
              >.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';

export default {
  name: 'ContactInformation',

  data() {
    return {
      email: null,
      address: null,
    };
  },

  created() {
    this.getContactInformation();
  },
  methods: {
    getContactInformation() {
      this.axios
        .get(formatUrl('/omnis/v3/contact/get-contact-information/'))
        .then(({data}) => {
          if (data && data.address) {
            this.address = data.address;
          }

          if (data && data.email) {
            this.email = data.email;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-information {
  .address {
    font-size: 14px;
    line-height: 16px;
  }

  .smaller {
    font-size: 12px;
    line-height: 14px;
    display: block;
  }
}
</style>
